import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum IntegrationIds {
  qualifications = 'qualifications',
  approval = 'approval', // delete
  hours_account = 'hours_account',
  hours_account_v2 = 'hours_account_v2',
  checklist = 'checklist',
  estimates = 'calculations',
  detailedCalculations = 'detailed_calculations',
  chats = 'chats',
  huldt_lillevik = 'huldt_lillevik',
  nettlonn = 'nettlonn',
  unimicro = 'unimicro',
  visma_payroll = 'visma_payroll',
  power_office_go = 'power-office-go',
  visma_eaccounting = 'visma-eaccounting',
  x_ledger = 'x_ledger',
  tripletex = 'tripletex'
}

export const ExternalIntegrationLabels = new Map<IntegrationIds, string>([
  [IntegrationIds.huldt_lillevik, marker('Huldt & Lillevik')],
  [IntegrationIds.nettlonn, marker('Nettlønn')],
  [IntegrationIds.unimicro, marker('Unimicro Economy')],
  [IntegrationIds.visma_payroll, marker('Visma Payroll')],
  [IntegrationIds.power_office_go, marker('PowerOffice Go')],
  [IntegrationIds.visma_eaccounting, marker('Visma eAccounting')],
  [IntegrationIds.x_ledger, marker('Xledger')],
  [IntegrationIds.tripletex, marker('Tripletex')]
]);
